/** @format */

import { useState } from "react";
import styles from "./styles.module.css";
import { IAccountsList } from "../../MainContent.types";
import { Button, Input, message, Spin } from "antd";
import { CheckOutlined, CloseOutlined, EditOutlined } from "@ant-design/icons";
import VoiceGainAuthSvcApi from "../../../../apis/VoiceGainAuthSvcApi";

interface IAccountRatesProps {
	account: IAccountsList | undefined;
}

type IEditingValues = {
	apiRequestLimitPerHour: number;
	apiRequestLimitPerMinute: number;
	asrConcurrencyLimit: number;
	offlineQueueSizeLimit: number;
	offlineThroughputLimitPerHour: number;
	offlineWorkerLimit: number;
};

function AccountRates({ account }: IAccountRatesProps) {
	const [isEditing, setIsEditing] = useState(false);
	const [loading, setLoading] = useState(false);
	const [editingValues, setEditingValues] = useState({
		apiRequestLimitPerHour: 0,
		apiRequestLimitPerMinute: 0,
		asrConcurrencyLimit: 0,
		offlineQueueSizeLimit: 0,
		offlineThroughputLimitPerHour: 0,
		offlineWorkerLimit: 0,
	});

	function setcurrentstate() {
		setEditingValues({
			apiRequestLimitPerHour: account!.limits.apiRequestLimitPerHour,
			apiRequestLimitPerMinute: account!.limits.apiRequestLimitPerMinute,
			asrConcurrencyLimit: account!.limits.asrConcurrencyLimit,
			offlineQueueSizeLimit: account!.limits.offlineQueueSizeLimit,
			offlineThroughputLimitPerHour:
				account!.limits.offlineThroughputLimitPerHour,
			offlineWorkerLimit: account!.limits.offlineWorkerLimit,
		});
	}

	function updateRateLimits() {
		setLoading(true);
		VoiceGainAuthSvcApi.putEditRateLimits(
			editingValues,
			account!.accountId
		).then((response) => {
			setLoading(false);
			if (!response.ok) {
				setIsEditing(false);
				message.error(`Failed to update rate limits`);
				return;
			}
			message.success("Successfully updated rate limits");
			setIsEditing(false);
		});
	}

	return (
		<div className={styles.main_div}>
			{loading ? (
				<div className={styles.loading_div}>
					<Spin size="large" />
				</div>
			) : null}
			<div className={styles.top_div}>
				{isEditing ? null : (
					<Button
						icon={<EditOutlined />}
						style={{
							position: "absolute",
							right: "10px",
						}}
						onClick={() => {
							setcurrentstate();
							setIsEditing(true);
						}}>
						Edit
					</Button>
				)}
				Rate-Limits
			</div>
			<div className={styles.row_div}>
				<div className={styles.row_left}>Api Request Limit Per-Hour</div>
				<div className={styles.divider_horiz} />
				{isEditing ? null : account!.limits.apiRequestLimitPerHour}
				{!isEditing ? null : (
					<Input
						style={{ width: "30%" }}
						title="Api Request Limit Per-Hour"
						value={editingValues.apiRequestLimitPerHour}
						onChange={(e) => {
							const value = e.target.value;
							setEditingValues((prev: IEditingValues) => ({
								...prev,
								apiRequestLimitPerHour: Number(value),
							}));
						}}
					/>
				)}
			</div>
			<div className={styles.row_div}>
				<div className={styles.row_left}>Api Request Limit Per-Minute</div>
				<div className={styles.divider_horiz} />
				{isEditing ? null : account!.limits.apiRequestLimitPerMinute}
				{!isEditing ? null : (
					<Input
						style={{ width: "30%" }}
						title="Api Request Limit Per-Minute"
						value={editingValues.apiRequestLimitPerMinute}
						onChange={(e) => {
							const value = e.target.value;
							setEditingValues((prev: IEditingValues) => ({
								...prev,
								apiRequestLimitPerMinute: Number(value),
							}));
						}}
					/>
				)}
			</div>
			<div className={styles.row_div}>
				<div className={styles.row_left}>Asr Concurrency Limit</div>
				<div className={styles.divider_horiz} />
				{isEditing ? null : account!.limits.asrConcurrencyLimit}
				{!isEditing ? null : (
					<Input
						style={{ width: "30%" }}
						title="Asr Concurrency Limit"
						value={editingValues.asrConcurrencyLimit}
						onChange={(e) => {
							const value = e.target.value;
							setEditingValues((prev: IEditingValues) => ({
								...prev,
								asrConcurrencyLimit: Number(value),
							}));
						}}
					/>
				)}
			</div>
			<div className={styles.row_div}>
				<div className={styles.row_left}>Offline Queue Size Limit</div>
				<div className={styles.divider_horiz} />
				{isEditing ? null : account!.limits.offlineQueueSizeLimit}
				{!isEditing ? null : (
					<Input
						style={{ width: "30%" }}
						title="Offline Queue Size Limit"
						value={editingValues.offlineQueueSizeLimit}
						onChange={(e) => {
							const value = e.target.value;
							setEditingValues((prev: IEditingValues) => ({
								...prev,
								offlineQueueSizeLimit: Number(value),
							}));
						}}
					/>
				)}
			</div>
			<div className={styles.row_div}>
				<div className={styles.row_left}>
					Offline Through-put Limit Per-Hour
				</div>
				<div className={styles.divider_horiz} />
				{isEditing ? null : account!.limits.offlineThroughputLimitPerHour}
				{!isEditing ? null : (
					<Input
						style={{ width: "30%" }}
						title="Offline Through-put Limit Per-Hour"
						value={editingValues.offlineThroughputLimitPerHour}
						onChange={(e) => {
							const value = e.target.value;
							setEditingValues((prev: IEditingValues) => ({
								...prev,
								offlineThroughputLimitPerHour: Number(value),
							}));
						}}
					/>
				)}
			</div>
			<div className={styles.row_div}>
				<div className={styles.row_left}>Offline Worker Limit</div>
				<div className={styles.divider_horiz} />
				{isEditing ? null : account!.limits.offlineWorkerLimit}
				{!isEditing ? null : (
					<Input
						style={{ width: "30%" }}
						title="Offline Worker Limit"
						value={editingValues.offlineWorkerLimit}
						onChange={(e) => {
							const value = e.target.value;
							setEditingValues((prev: IEditingValues) => ({
								...prev,
								offlineWorkerLimit: Number(value),
							}));
						}}
					/>
				)}
			</div>
			<div className={styles.bottom_divider} />
			{isEditing ? (
				<div className={styles.bottom_div}>
					<Button
						icon={<CloseOutlined />}
						onClick={() => {
							setIsEditing(false);
							setcurrentstate();
						}}>
						Cancel
					</Button>
					<Button
						onClick={updateRateLimits}
						style={{ marginLeft: "10px" }}
						icon={<CheckOutlined />}>
						Save
					</Button>
				</div>
			) : null}
		</div>
	);
}

export default AccountRates;
